import { useNavigate } from 'react-router-dom';
import './header.scss';
import { useState } from "react";

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);

    const navigate = useNavigate();

    function navigateTo(path){
        navigate(path);
    }

  return (
    <header className="header shadow-md fixed w-full top-0 left-0 z-50">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 w-full">
          
          {/* Logo on Left */}
          <div className="text-3xl text-white flex items-center mt-3" style={{cursor: 'pointer'}} onClick={() => navigateTo('/home')}>
            JANAS
          </div>

          {/* Links on Right (Desktop) */}
          <nav className="hidden md:flex md:ml-auto space-x-8 font-medium mt-3">
            <button className="btn-link" onClick={() => navigateTo('/rooms')}>Rooms</button>
            <button className="btn-link" onClick={() => navigateTo('/gallery')}>Gallery</button>
            <button className="btn-link" onClick={() => navigateTo('/about-us')}>About us</button>
            <button className="btn-link" onClick={() => navigateTo('/contact-us')}>Contact us</button>
            {/* <a href="/" className="hover:text-blue-600">Home</a>
            <a href="/rooms" className="hover:text-blue-600">Rooms</a>
            <a href="/contact" className="hover:text-blue-600">Contact</a> */}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden fixed top-16 left-0 right-0 mobile-menu-overlay">
          <nav className="flex flex-col space-y-2 px-4 py-4 text-white font-medium">
            <div className="flex justify-end mb-2">
              <button
                onClick={() => setIsOpen(false)}
                className="text-white focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            {/* <a href="/" className="hover:text-blue-600">Home</a>
            <a href="/rooms" className="hover:text-blue-600">Rooms</a>
            <a href="/contact" className="hover:text-blue-600">Contact</a> */}
            <button className="btn-link" onClick={() => { navigateTo('/rooms'); setIsOpen(false); }}>Rooms</button>
            <button className="btn-link" onClick={() => { navigateTo('/gallery'); setIsOpen(false); }}>Gallery</button>
            <button className="btn-link" onClick={() => { navigateTo('/about-us'); setIsOpen(false); }}>About us</button>
            <button className="btn-link" onClick={() => { navigateTo('/contact-us'); setIsOpen(false); }}>Contact us</button>
          </nav>
        </div>
      )}
    </header>
  );
}
